import styles from '@/styles/csotd/countdown.module.scss'
import { useState, useEffect } from 'react'
import { Timer } from '@/utils/countDown'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Image from 'next/image'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

dayjs.extend(duration)

interface PromotionProps {
  currentTime: string;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    discountPercent: string;
    ebaySync: number;
  };
  crazyDeal: {
    hoursLeft: number;
    minutesLeft: number;
    secondsLeft: number;
  } | undefined
}

export default function CountDown({ currentTime, promotion, crazyDeal }: PromotionProps) {

  // 检测是否为Firefox浏览器
  const isFirefox = typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase().includes('firefox');

  let timer = new Timer()
  interface TimeRemaining {
    days: number,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  // 倒计时计算
  const [days, setDays] = useState(0)
  const [timeDetail, setTimeDetail] = useState<string[]>([])
  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        let isPromotionEnd = currentTime < promotion.endDate
        console.log(isPromotionEnd, ' == isPromotionEnd => reload');

        if (isPromotionEnd || promotion.promotionType == 1) {
          location.reload()
        }
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = days * 24 + parseInt(hours)
        if (hh <= 99) {
          hh < 10 ? hh = '0' + hh : hh = `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  useEffect(() => {
    // csotd, 从数据返回拿
    if (
      promotion.promotionType == 1
      && (crazyDeal?.hoursLeft || crazyDeal?.minutesLeft || crazyDeal?.secondsLeft)
    ) {
      setDays(days)
      // 结束时间
      const time = new Date().getTime() + (60 * 60 * crazyDeal.hoursLeft + 60 * crazyDeal.minutesLeft + crazyDeal.secondsLeft) * 1000
      countDown(time)
    }
  }, [])

  return (
    <>
      {/* Csotd */}
      {(promotion.promotionType == 1 && timeDetail.length > 0) && (
        <div className={styles['promotion-box']}>
          <div className={styles['promotion-ipad']}>
            <div>
              <Image src={`${imageDomain}/24HoursClock.png`} width={184} height={178} layout="intrinsic" alt="24HoursClock" />
            </div>
            <div>
              <div className={styles['promotion-ipad-title']}>
                Best Deal of the day
              </div>

              <div className={`${styles['promotion-ipad-desc']} margin-top-6`}>
                <b>TIME LEFT : </b>
              </div>

              <div className={`${styles['promotion-ipad-countdown']} margin-top-4`}>
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px' }}
                >
                  {timeDetail[0]}
                </div>
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px' }}
                >
                  {timeDetail[1]}
                </div>
                :
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px' }}
                >
                  {timeDetail[2]}
                </div>
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px' }}
                >
                  {timeDetail[3]}
                </div>
                :
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px' }}
                >
                  {timeDetail[4]}
                </div>
                <div
                  className={styles['countdown-item']}
                  style={{ lineHeight: isFirefox ? '44px' : '40px'}}
                >
                  {timeDetail[5]}
                </div>

                <Image src={`${imageDomain}/otd-start.png`} className={styles['csotd-bg-left']} width={46} height={42} layout="intrinsic" alt="csotd-bg-left" />
                <Image src={`${imageDomain}/otd-start.png`} className={styles['csotd-bg-right']} width={46} height={42} layout="intrinsic" alt="csotd-bg-left" />
              </div>

              <div
                className={`${styles['promotion-ipad-desc']} margin-top-6`}
                style={{ fontSize: '12px' }}
              >
                24 hours only! Don&apos;t Miss Out
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}